import {
    StyleSheet
} from "react-native";
import type {
    CardTitleVariantConstantType
} from "./type";

export const CARD_TITLE_SKELETON_WIDTH = "60%";

export const getCardTitleVariant = ({
    isMetric
}: CardTitleVariantConstantType): keyof NCoreUIKit.Typography => {
    return isMetric ? "headlineMediumSize" : "titleMediumSize";
};

const stylesheet = StyleSheet.create({
    metric: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});
export default stylesheet;
